import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import "./ModalPageEvent.css";

const ModalPage = (props) => {

    const { t } = useTranslation();
    const { show, setShow, title, child, size, centered = false, btnCloseOnClick, dialogClassName } = props;

    const handleClose = () => {
        (!btnCloseOnClick) ? setShow(false) : btnCloseOnClick();
    }

    const resolvedDialogClassName = ['modal-page-event__dialog', dialogClassName].filter(Boolean).join(' ');

    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade modal-page-event" size={size} show={show} onHide={handleClose} centered={centered} dialogClassName={resolvedDialogClassName}>
                <Modal.Header className="modal-page-event__header">
                    <Modal.Title className="modal-page-event__title">{title}</Modal.Title>
                    <button
                        type="button"
                        onClick={handleClose}
                        className="modal-page-event__close"
                        aria-label={t('close')}
                        title={t('close')}
                    >
                        <i className="fa-solid fa-xmark" aria-hidden="true" />
                    </button>
                </Modal.Header>
                <Modal.Body className="modal-page-event__body">
                   {child}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalPage;
